import SwiperCore, { Controller, Lazy, Navigation, Scrollbar, } from "swiper/core";
import "swiper/swiper-bundle.min.css";
// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Navigation, Lazy, Controller, Scrollbar]);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.swiper = new SwiperCore(".swiper-container", {
    freeMode: true,
    freeModeMomentumRatio: 1,
    freeModeMomentum: true,
    allowTouchMove: true,
    simulateTouch: true,
    preventClicks: true,
    preloadImages: false,
    watchOverflow: true,
    lazy: {
        loadPrevNext: true,
        checkInView: true,
    },
    breakpoints: {
        100: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        250: {
            slidesPerView: 2,
            spaceBetween: 0,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 0,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 0,
        },
        1200: {
            slidesPerView: 6,
            spaceBetween: 0,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        hideOnClick: true,
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
    },
});
